export const gabaMidnight = require('./sprites/gabaMidnight.png');
export const twitter = require('./sprites/twitter.svg');
export const In = require('./sprites/in.svg');
export const icon_send_mail = require('./sprites/icon-send-mail.svg');
export const img_user = `import img_user from './sprites/avatar-person.svg'`;
export const img_locker = require('./photos/img-locker.jpg');
export const img_account = require('./sprites/icons-account.svg');
export const img_board = require('./photos/img-board.jpg');
export const right_arrow = require('./sprites/right-arrow.png');
export const down_arrow = require('./sprites/arrow-down.png');
export const verified_check = require('./sprites/verified_check.svg');
export const oval = require('./sprites/oval.svg');
export const bag = require('./sprites/Bag.svg');
export const right_arrow_black = require('./sprites/right-arrow-black.png');
export const step_one = require('./sprites/step-one-icon.svg');
export const step_two = require('./sprites/step-two-icon.svg');
export const step_three = require('./sprites/step-three-icon.png');
export const mcat = require('./sprites/mcat-icon.svg');
export const gaba = require('./sprites/GABA.svg');
export const search_icon = require('./sprites/search-icon.svg');
export const nav_icon = require('./sprites/nav-icon.svg');
